import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Input } from 'reactstrap';
import { toast } from 'react-toastify';
import CustomModal from '../../../../../../CustomModal';
import InfoPopup from '../../../../../../InfoPopup';
import SpinnerCircles from '../../../../../../Spinner/SpinerCircles';
import { format } from 'date-fns';
import { useUnifiedFetch, useUnifiedMutate } from '../../../../../../../hooks';
import addNote from '../../../../../../../lib/api/addNote';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import './index.css';

const transformAdminFlagsResponse = (data) => {
  return [
    { name: 'VTM Scheduled', key: 'vtmScheduled', ...data?.vtmScheduled},
    { name: 'High Visibility', key: 'highVisibility', isChecked: data?.highVisibility },
    { name: 'Custom Dial Plan', key: 'customDialPlan', isChecked: data?.customDialPlan },
    { name: 'Custom Configuration', key: 'customConfiguration', isChecked: data?.customConfiguration },
    { name: 'Customer Install', key: 'customerInstall', isChecked: data?.customerInstall },
    { name: 'Escalate to Engineering', key: 'escalateToEngineering', isChecked: data?.escalateToEngineering },
    { name: 'POC', key: 'poc', isChecked: data?.poc },
    { name: 'Fire Watch', key: 'fireWatch', isChecked: data?.fireWatch },
    { name: 'Open Repair Ticket', key: 'openRepairTicket', ...data?.openRepairTicket },
    { name: 'Alarm Monitoring Company', key: 'alarmMonitoringCompanyCutover', isChecked: data?.alarmMonitoringCompanyCutover },
    { name: 'Delivered Dial tone - Cutover TBD', key: 'deliveredDialToneCutover', isChecked: data?.deliveredDialToneCutover },
    { name: 'LTE Only - LAN TBD', key: 'lteOnlyLan', isChecked: data?.lteOnlyLan },
    { name: 'LTE Only', key: 'lteOnly', isChecked: data?.lteOnly },
  ];
};

// Component
export const AdminFlags = ({ loading, boxId }) => {
  const [showAdminFlags, setShowAdminFlags] = useState(false);
  const [adminValues, setAdminValues] = useState([]);
  const [originalAdminValues, setOriginalAdminValues] = useState([]);
  const [adminFlagId, setAdminFlagId] = useState('');
  const [isValidTicketNum, setIsValidTicketNumber] = useState(false)
  const dispatch = useDispatch()

  const {
    isLoading,
    data,
    fetchData,
  } = useUnifiedFetch(`boxes/${boxId}/admin-flags`, false);

  const { mutate: adminFlagsMutate, isLoading: isAdminFlagsMutating } = useUnifiedMutate();

  const openRepairTicket = adminValues?.find(admVal => admVal?.key === 'openRepairTicket' && admVal?.ticketNumber)
  const {
    isLoading: isFetchingTicketNumber,
    data: openRepairTicketResponse,
    fetchData: fetchTicketNumber,
  } = useUnifiedFetch(`boxes/connectwise/${openRepairTicket?.ticketNumber}/search`, false, true);

  useEffect(() => {
    const checkValidTicketNumber = () => {
      if ((!openRepairTicketResponse && data?.openRepairTicket?.isChecked && data?.openRepairTicket?.ticketNumber === openRepairTicket?.ticketNumber) ||
        (openRepairTicketResponse?.ticketNumber && openRepairTicket?.ticketNumber?.toString() === openRepairTicketResponse?.ticketNumber?.toString())) {
        setIsValidTicketNumber(true);
      } else {
        setIsValidTicketNumber(false);
      }
    };
    checkValidTicketNumber();
  }, [openRepairTicketResponse?.ticketNumber, openRepairTicket?.ticketNumber, data?.openRepairTicket?.ticketNumber]);



  useEffect(() => {
    if (!isFetchingTicketNumber) {
      if (openRepairTicketResponse?.succes === true) {
        toast.success('TicketNumber linked successfully');
      } else if (openRepairTicketResponse?.succes === false) {
        toast.error('Error while Linking Ticket Number');
      }
    }
  }, [openRepairTicketResponse, isFetchingTicketNumber]);

  useEffect(() => {
    if (showAdminFlags) {
      fetchData();
    }
  }, [showAdminFlags]);

  useEffect(() => {
    if (data) {
      const transformedData = transformAdminFlagsResponse(data);
      const transformedDataOriginalValues = JSON.parse(JSON.stringify(transformedData));
      setAdminValues(transformedData);
      setOriginalAdminValues(transformedDataOriginalValues);
      if(data?._id){
        setAdminFlagId(data?._id)
      }
    }
  }, [data]);


  const onChangeAdminFlags = (e, index) => {
    const updatedValues = [...adminValues];
    if (e.target.type === 'checkbox') {
      updatedValues[index].isChecked = e.target.checked;
    } else {
      const { name, value } = e.target;
      updatedValues[index][name] = value;
    }
    setAdminValues(updatedValues);
  };

  const handleDateChange = (date, index) => {
    const updatedValues = [...adminValues];
    updatedValues[index].date = date;
    setAdminValues(updatedValues);
  };


  const getFlagsName = (body, adminValues) => {
    try {
      const adminKeys = Object.keys(body)
        .filter(key => key !== 'box')
        .filter(key => {
          if (typeof body[key] === 'object') {
            return body[key].isChecked === true;
          }
          return body[key] === true;
        });
      
      const flagsNames = adminKeys.map(key => {
        const flag = adminValues.find(flag => flag.key === key);
        return flag ? flag.name : key;
      }).join(',');
  
      return flagsNames;
    } catch (error) {
      console.error('Error getting flags names:', error.message);
      return '';
    }
  };

  

  const handleSave = async () => {
    try {
      const endpoint = `boxes/${boxId}/admin-flags`;
      let method = 'POST';
  
      if (adminFlagId) {
        method = 'PUT';
      }
  
      const body = {
        box: boxId,
      };
  
      adminValues.forEach((flag, index) => {
        const originalFlag = originalAdminValues[index];
        if (flag.key && flag.key !== 'name') {
          let hasChanged = false;
          if (flag.isChecked !== originalFlag.isChecked) {
            hasChanged = true;
          }
  
          if (flag.key === 'vtmScheduled' && (flag.date?.toString() !== originalFlag.date?.toString())) {
            hasChanged = true;
          }
  
          if (flag.key === 'openRepairTicket' && (flag.ticketNumber !== originalFlag.ticketNumber)) {
            hasChanged = true;
          }
  
          if (hasChanged) {
            if (flag.key === 'vtmScheduled') {
              body[flag.key] = {
                isChecked: (flag.date && flag.isChecked) ? flag.isChecked : false,
                date: (flag.date && flag.isChecked) ? format(new Date(flag.date), 'yyyy-MM-dd') : null
              };
            } else if (flag.key === 'openRepairTicket') {
              body[flag.key] = {
                isChecked:  (flag.ticketNumber && isValidTicketNum) ? flag.isChecked : false,
                ticketNumber: (flag.ticketNumber && flag.isChecked && isValidTicketNum) ? flag.ticketNumber : ''
              };
            } else if(flag.key !== 'vtmScheduled' && flag.key !== 'openRepairTicket') {
              body[flag.key] = flag.isChecked;
            }
          }
        }
      });

      const adminFlags = await adminFlagsMutate({ endpoint, method, body });
      if (adminFlags && !isAdminFlagsMutating) {
        const flagsNames = getFlagsName(body, adminValues);
        if(flagsNames){  
          await addNote({ boxID: body?.box, note: `Sets Admin Flags: ${flagsNames}`});
        }
        dispatch({
          type: 'GET_ADMIN_FLAGS_SUCCESS',
          adminFlags,
        });
        setAdminFlagId('')
        setOriginalAdminValues([])
        setAdminValues([])
        setShowAdminFlags(false)
      }
  
    } catch (error) {
      console.error('Error saving admin flags:', error.message);
    }
  };   

  return (
    <div className="modam-row mt-2">
      <h1 className="heading d-flex">
        Admin Flags
        <sup>
          <InfoPopup id="setAdminFlags" text='Set Admin Flags' />
        </sup>
      </h1>
      <Button
        disabled={isLoading}
        onClick={() => setShowAdminFlags(true)}
        color="primary"
        className="admin-tool-execute-btn"
      >
        Open
      </Button>
      <CustomModal
        isOpen={showAdminFlags}
        header="Set Admin Flags"
        onCancel={() => {setShowAdminFlags(false); setAdminFlagId('')}}
        onSave={adminValues.length > 0 && handleSave}
        saveLoading={isAdminFlagsMutating}
        saveBtnText='Set'
        medium
        customBodyClass={'custom-modal-body'}
      >
        <div className='admin-flags'>
          {
            isLoading ?  
            <div className="mb-5 mt-5" sm={12} style={{ padding: '1px 20px', fontWeight: 600, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <SpinnerCircles red />
            </div> :
            adminValues.length > 0 ? adminValues.map((el, index) => (
            <div key={el.name} className="mb-1" sm={12} style={{ padding: '1px 20px', display: 'flex', alignItems: 'center' }}>
              <div style={{ marginRight: '10px' }}>
                <Input
                  type="checkbox"
                  name="isChecked"
                  onChange={(e) => onChangeAdminFlags(e, index)}
                  checked={el.isChecked || false}
                  style={{ position: 'relative' }}
                />
              </div>
              <div style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
                <div style={{ minWidth: 'fit-content' }}>{el.name}</div>
                {el.name === 'VTM Scheduled' && (
                  <DatePicker
                    showIcon
                    selected={el.date ? el.date : ''}
                    onChange={(date) => handleDateChange(date, index)}
                    disabled={!el.isChecked}
                    name="date"
                    className={`custom-date-picker ${el.isChecked && 'selected'}`}
                  />
                )}
                {el.name === 'Open Repair Ticket' && (
                  <>
                    <Input
                      disabled={!el.isChecked}
                      type="text"
                      name="ticketNumber"
                      value={el.ticketNumber || ''}
                      onChange={(e) => onChangeAdminFlags(e, index)}
                      className="ml-2"
                      style={{ maxWidth: '200px' }}
                    />
                    <Button
                      disabled={!el.isChecked || !el.ticketNumber}
                      onClick={async () => openRepairTicket?.ticketNumber && await fetchTicketNumber()}
                      color="primary"
                      className="ml-2"
                    >
                      Link
                    </Button>
                    {isFetchingTicketNumber && <SpinnerCircles red />}
                  </>
                )}
              </div>
            </div>
            )) : 
            <div className="mb-5 mt-5" sm={12} style={{ padding: '1px 20px', fontWeight: 600, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              Something Went Wrong, Error while fetching Admin Flags!
            </div>
          }
          </div>
      </CustomModal>
    </div>
  );
};

export default AdminFlags;